import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ToastService,
  ToastInstance,
  ToastType,
} from 'src/app/providers/toast.service';
import { IonIcon } from '@ionic/angular/standalone';
import { BtnComponent } from '../btn/btn.component';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule, IonIcon, BtnComponent],
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
})
export class ToastComponent implements OnInit {
  toasts: ToastInstance[] = [];
  stackDirection: 'bottom' | 'top' | 'left' | 'right' = 'bottom';

  constructor(private toastService: ToastService) {}

  ngOnInit() {
    this.toastService.toasts$.subscribe((list) => {
      // stack direction
      if (list.length > 0) {
        this.stackDirection = list[list.length - 1].direction;
      }

      // record old positions
      const oldPositions = new Map<number, DOMRect>();
      document.querySelectorAll('.toast-wrapper[data-id]').forEach((el) => {
        oldPositions.set(
          Number(el.getAttribute('data-id')),
          (el as HTMLElement).getBoundingClientRect()
        );
      });

      this.toasts = list;

      requestAnimationFrame(() => {
        const wrappers = Array.from(
          document.querySelectorAll('.toast-wrapper[data-id]')
        ) as HTMLElement[];

        wrappers.forEach((el) => {
          const id = Number(el.getAttribute('data-id'));
          const oldRect = oldPositions.get(id);
          if (!oldRect) return;

          const newRect = el.getBoundingClientRect();
          const deltaX = oldRect.left - newRect.left;
          const deltaY = oldRect.top - newRect.top;

          if (Math.abs(deltaX) < 1 && Math.abs(deltaY) < 1) return;

          el.style.transition = 'none';
          el.style.transform = `translate(${deltaX}px, ${deltaY}px)`;

          requestAnimationFrame(() => {
            el.style.transition = 'transform 350ms ease, opacity 350ms ease';
            el.style.transform = '';
          });
        });

        // Fade-in
        requestAnimationFrame(() => {
          this.toasts.forEach((t) => (t.visible = true));
        });
      });
    });
  }

  btnType(type: ToastType): 'primary' | 'danger' | 'warning' | 'neutral' {
    return type === 'success'
      ? 'primary'
      : type === 'danger'
      ? 'danger'
      : 'warning';
  }

  trackById(_: number, item: ToastInstance) {
    return item.id;
  }

  icon(type: ToastInstance['type']) {
    return type === 'success'
      ? 'checkmark-circle-outline'
      : type === 'danger'
      ? 'close-circle-outline'
      : 'alert-circle-outline';
  }

  removeOnClick(toast: ToastInstance) {
    this.toastService.remove(toast);
  }

  handleToastAction(toast: ToastInstance) {
    toast.onButtonClick?.(toast.infoToUse);
    this.toastService.remove(toast);
  }

  /* -------------------------------------------------- */
  /* SWIPE TO DISMISS (CARD ONLY) */
  /* -------------------------------------------------- */

  private swipeStartX = 0;
  private isSwiping = false;
  private deltaX = 0;

  startSwipe(event: TouchEvent | MouseEvent, el: HTMLElement) {
    const point = event instanceof TouchEvent ? event.touches[0] : event;
    this.swipeStartX = point.clientX;
    this.isSwiping = true;

    console.log(this.swipeStartX);
  }

  moveSwipe(event: TouchEvent | MouseEvent, wrapperEl: HTMLElement) {
    if (!this.isSwiping) return;

    const card = wrapperEl.querySelector('.toast-card') as HTMLElement;
    if (!card) return;

    const point = event instanceof TouchEvent ? event.touches[0] : event;
    this.deltaX = point.clientX - this.swipeStartX;

    card.style.transition = 'none';
    card.style.transform = `translate(${this.deltaX}px)`;
    card.style.opacity = `${1 - Math.min(0.7, Math.abs(this.deltaX) / 250)}`;

    console.log(this.deltaX);
  }

  endSwipe(wrapperEl: HTMLElement, toast: ToastInstance) {
    if (!this.isSwiping) return;
    this.isSwiping = false;

    const card = wrapperEl.querySelector('.toast-card') as HTMLElement;
    if (!card) return;

    const rect = card.getBoundingClientRect();

    const threshold = 60;
    const dismiss = Math.abs(this.deltaX) > threshold;

    if (dismiss) {
      card.style.transition = 'transform 350ms ease, opacity 200ms ease';
      card.style.transform = `translate(${this.deltaX * 3}px) scale(0.2)`;
      card.style.opacity = '0';

      setTimeout(() => this.toastService.swipeRemove(toast), 350);
    } else {
      card.style.transition = 'transform 250ms ease, opacity 250ms ease';
      card.style.transform = 'translate(0,0)';
      card.style.removeProperty('opacity');
    }
  }
}
